import { Button, Grid } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TimelinePageStore from "../store/TimelinePageStore";
import { observer } from "mobx-react";

interface EvalHeaderProps {
  pageStore: TimelinePageStore;
}

function EvalHeader({ pageStore }: EvalHeaderProps) {
  return (
    <Grid container justifyContent={'space-evenly'} gap={2} style={{ marginTop: '40px' }}>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            margin: 0,
          }}
        >
          {pageStore.last30dayAvg.toFixed(2)}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#888889',
            marginTop: '6px',
          }}
        >
          Last 30 days
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            margin: 0,
          }}
        >
          {pageStore.quarterAvg.toFixed(2)}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#888889',
            marginTop: '6px',
          }}
        >
          Quarter
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            margin: 0,
          }}
        >
          {pageStore.halfAvg.toFixed(2)}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#888889',
            marginTop: '6px',
          }}
        >
          Half-Year
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            margin: 0,
          }}
        >
          {pageStore.yearAvg.toFixed(2)}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#888889',
            marginTop: '6px',
          }}
        >
          Full-Year
        </Typography>
      </Grid>
    </Grid>
  );
}

export default observer(EvalHeader);
